var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',_vm._b({class:_vm.icon ? 'text-center' : '',style:({ backgroundColor: _vm.bgColor }),attrs:{"pill":_vm.pill,"variant":_vm.variant}},'b-badge',_vm.$attrs,false),[(!_vm.icon)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_c('font-awesome-icon',{staticClass:"mx-0 px-0",attrs:{"icon":_vm.statusIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }